<mbs-wizard
  class="mbs-wizard_flex-content"
  [backButton]="{ text: 'shared:buttons.back' | i18next }"
  [buttonLoadingMode]="true"
  [cancelButton]="{ hide: false, text: 'shared:buttons.close' | i18next }"
  [canClosed]="!loading() && wizardFinish()"
  [closeHandler]="closeHandler"
  [loading]="loading()"
  [nextButton]="{ text: 'shared:buttons.next' | i18next }"
  [ngModel]="currentStep()"
  [saveButton]="{ hide: true }"
  [scrollableStepContent]="true"
  [stepsOrientation]="'vertical'"
  [title]="'wizards:entityWizards.company.title' | i18next"
  (ngModelChange)="currentStep.set($event)">
  <mbs-wizard-step
    [title]="stepTitles.name"
    [valid]="companyNameStep?.valid()"
    (next)="companyNameStep?.forceValid(currentStep())">
    <mbs-company-name-step
      #companyNameStep
      [(value)]="nameStep"
      (nextStep)="forceNextStepWizard(!!$event)" />
  </mbs-wizard-step>

  @if (ability.can('read', PermissionsEnum.Administrator)) {
    <mbs-wizard-step
      [e2eLocator]="elementSelectors.name.administratorsStep"
      [title]="stepTitles.administrators"
      [valid]="true">
      <mbs-company-administrators-step [(value)]="administratorsStep" />
    </mbs-wizard-step>
  }

  @if (ability.can('read', PermissionsEnum.AddOrRemoveDestinationForCompany)) {
    <mbs-wizard-step
      [e2eLocator]="elementSelectors.name.destinationsStep"
      [title]="stepTitles.destinations"
      [valid]="true">
      <mbs-company-destinations-step />
    </mbs-wizard-step>

    @if (ability.can('read', PermissionsEnum.RemoteDeploy)) {
      <mbs-wizard-step
        [e2eLocator]="elementSelectors.name.templatesStep"
        [title]="stepTitles.templates"
        [valid]="companyBackupTemplatesStep?.valid()"
        (next)="companyBackupTemplatesStep?.forceValid()">
        <mbs-company-backup-templates-step
          #companyBackupTemplatesStep
          [(value)]="backupTemplatesStep"
          (goToDestinations)="goToDestinationsHandler()"
          (nextStep)="forceNextStepWizard(!!$event)" />
      </mbs-wizard-step>
    }
  }

  <mbs-wizard-step
    [title]="stepTitles.summary"
    [valid]="true">
    <mbs-company-summary-step
      [administrators]="administratorsStep().administrators"
      [templates]="backupTemplatesStep().templates" />
  </mbs-wizard-step>

  @if (ability.can('read', PermissionsEnum.Downloads)) {
    <mbs-wizard-step
      [e2eLocator]="elementSelectors.name.downloadStep"
      [title]="stepTitles.download"
      [valid]="true">
      <mbs-company-download-step [(value)]="downloadStep" />
    </mbs-wizard-step>
  }
</mbs-wizard>
